import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export type ModerationFilter = {
    id: string;
    label: TLabel;
    emoji?: string;
};

export const ModerationFilters: Record<string, ModerationFilter> = {
    AwaitingDecision: { id: 'awaiting_decision', label: t('Awaiting decision'), emoji: '🔍' },
    AutomaticallyApproved: { id: 'auto_approved', label: t('Automatically approved'), emoji: '✅' },
    HumanApproved: { id: 'human_approved', label: t('Manually approved'), emoji: '🕵️' },
    Rejected: { id: 'rejected', label: t('Manually rejected'), emoji: '⛔️' },
    Warned: { id: 'warned', label: t('Warnings'), emoji: '🚦' },
    Deleted: { id: 'deleted', label: t('Deleted by user'), emoji: '🗑️' },
    Bookmarked: { id: 'bookmarked', label: t('My bookmarks'), emoji: '🔖' },
};

export enum ThreadFilters {
    OPEN = 'open',
    CLOSED = 'closed',
    HEATED = 'heated',
    FLAGGED = 'flagged',
}

export type ThreadFilterSelection = {
    [ThreadFilters.OPEN]: boolean;
    [ThreadFilters.CLOSED]: boolean;
    [ThreadFilters.HEATED]: boolean;
    [ThreadFilters.FLAGGED]: boolean;
};

export const ModerationFiltersDefault = [
    ModerationFilters.AwaitingDecision,
    ModerationFilters.AutomaticallyApproved,
    ModerationFilters.HumanApproved,
    ModerationFilters.Rejected,
];
